<template>
          <section>
        <v-container grid-list-xl>
          <v-layout row wrap justify-center class="my-5">
            <v-flex xs12 sm4>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">Servicios</div>
                </v-card-title>
                <v-card-text>
                    <ul>
                        <li>Tasamos gratuitamente y de forma verbal su inmueble.</li>
                        <li>Gestionamos todos los trámites y documentación.</li>
                        <li>Búsqueda de la mejor financiación.</li>
                        <li>Gran cartera de pisos, casas, locales, parkings y naves en venta o alquiler.</li>
                        <li>Alquilamos su piso con una selección previa de posibles inquilinos.</li>
                        <li>Tramitamos cédulas de habitabilidad.</li>
                        <li>Atención personalizada de principio a fin.</li>
                    </ul>
                </v-card-text>
              </v-card>
            </v-flex>
            <ContactCard />
          </v-layout>
        </v-container>
      </section>
</template>

<script>
import ContactCard from '@/components/contactCard.vue'

export default {
    components : {
        ContactCard
    }
}
</script>
